// X2 (2026-10-27): Dismiss hides the pending-clients banner until the browser
// session ends. Storage access throws in private windows and when site data
// is blocked; the banner then shows, and a dismissal lasts only this visit.
const DISMISSED_KEY = "usnara.admin.clients.pendingBannerDismissed";

export const isPendingBannerDismissed = (): boolean => {
    try {
        return window.sessionStorage.getItem(DISMISSED_KEY) === "true";
    } catch {
        return false;
    }
};

export const rememberPendingBannerDismissed = (): void => {
    try {
        window.sessionStorage.setItem(DISMISSED_KEY, "true");
    } catch {
        // Not remembered; the caller still hides the banner for this visit.
    }
};
